<template>
    <el-dialog
        title="上传设计文件"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="800px">
        <div class="uploadDesignFilesContent">
            <el-form :model="form" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
                <el-form-item label="上传设计文件" prop="modelList">
                    <!-- <uploadFile
                        :buttonName="'点击上传'"
                        :fileList="form.modelList"
                        @fileListChange="fileListChange"
                        @deleteFile="deleteFile"
                        @getDragFile="getDragFile"
                    ></uploadFile> -->
                    <uploadFile
                        :buttonName="'点击上传'"
                        :fileList="form.modelList"
                        @fileListChange="fileListChange"
                        @deleteFile="deleteFile"
                        @getDragFile="getDragFile"
                    >
                    </uploadFile>
                     <el-input  v-model="form.modelList" v-show="false"></el-input>
                </el-form-item>
                <el-form-item label="设计描述" prop="description">
                    <el-input type="textarea" v-model="form.description"></el-input>
                </el-form-item>
                <el-form-item label="附件上传" prop="fileList">
                    <uploadFile
                        :buttonName="'点击上传'"
                        :fileList="form.fileList"
                        @fileListChange="fileListChange2"
                        @deleteFile="deleteFile2"
                        @getDragFile="getDragFile2"
                    ></uploadFile>
                    <span style="color:#999;font-size:14px">买家未确认验收前，可下载附件文件，为保护您的权益，请勿将设计源文件文件上传至附件</span>
                    <!-- <span style="color:rgb(220, 223, 230);font-size:14px">请上传附件</span> -->
                </el-form-item>
                <el-form-item class="submitButtonGroup">
                    <el-button type="primary" @click="submit()">提交</el-button>
                    <el-button @click="dialogVisible = false">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </el-dialog>

</template>

<script>
import { saveDesignerFile,updateDesignOrderStatus,demandDetail } from '../../../utils/interface';
import uploadFile from '@/components/uploadFile'
import modelUpload from '@/components/modelUpload'
export default {
    name: "uploadDesignFiles",
    data(){
        return{
            dialogVisible: false,
            demandUuid:"",
            uuid:"",
            form: {
                fileList: [],
                description: '',
                modelList: [],
            },
            rules: {
                fileList: [
                    {required: true, message: '请上传附件',trigger:'blur'}
                ],
                description: [
                    {required: true, message: '请进行设计文件描述',trigger:'blur'}
                ],
                modelList: [
                    {required: true, message: '请上传设计附件',trigger:['blur','change']}
                ],
            },
            fileTypes:[],
        }
    },
    components: {
        uploadFile,
        modelUpload
    },
    methods: {
        init(val,item){
            this.reset();
            this.dialogVisible = val;
            this.uuid = item.uuid;
            this.demandUuid = item.demandUuid;
            demandDetail(item.demandUuid).then((res)=>{
                console.log(res);
                if(res != null) {
                    this.fileTypes = res.fileType.split("、");
                }
            });
        },
        // 表单重置
        reset(){
            this.form = {
                fileList: [],
                description:"",
                modelList: [],
            }
        },
        // 获取拖拽后的文件
        fileListChange(file){
            let fileType = file.url.substring(file.url.lastIndexOf('.'), file.url.length).toUpperCase();
            if(this.fileTypes.length > 0 && this.fileTypes.indexOf(fileType) > -1){
                this.form.modelList = file;
                this.$refs.ruleForm.validateField('modelList')
            }else{
                this.$message.error('所上传交付文件类型与需求指定文件类型不符，请修改后再执行当前操作！');
            }
        },
        // 删除文件
        deleteFile(file){
            this.form.modelList = file;
            this.$refs.ruleForm.validateField('modelList')
        },
        // 上传文件
        getDragFile(file){
            let fileType = file.url.substring(file.url.lastIndexOf('.'), file.url.length).toUpperCase();
            if(this.fileTypes.length > 0 && this.fileTypes.indexOf(fileType) > -1){
                this.form.modelList = file;
                this.$refs.ruleForm.validateField('modelList')
            } else{
                this.$message.error('所上传交付文件类型与需求指定文件类型不符，请修改后再执行当前操作！');
            }
        },
        // 获取拖拽后的文件
        fileListChange2(file){
            /*this.form.fileList.push({
                fileUrl:file.url,
                fileName:file.name
            });*/
            this.$refs.ruleForm.validateField('fileList')
        },
        // 删除文件
        deleteFile2(file){
            this.form.fileList = file;
            this.$refs.ruleForm.validateField('fileList')
        },
        // 上传文件
        getDragFile2(file){
            this.form.fileList = file;
            this.$refs.ruleForm.validateField('fileList')
        },
        // 提交
        submit(){
            this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
                        this.form.demandUuid = this.demandUuid;
                        saveDesignerFile(this.form).then((res)=>{
                            if(res.success){
                                updateDesignOrderStatus({uuid:this.uuid,status:"UN_CONFIRM"}).then((res)=>{
                                    if(res.success){
                                        this.$message.success('保存成功！');
                                        this.dialogVisible = false;
                                        this.$emit('submit');
                                    }
                                });
                            }
                        });
					} else {
						return false;
					}
				});
            // this.form.demandUuid = this.demandUuid;
            // saveDesignerFile(this.form).then((res)=>{
            //     if(res.success){
            //         updateDesignOrderStatus({uuid:this.uuid,status:"UN_CONFIRM"}).then((res)=>{
            //             if(res.success){
            //                 this.$message.success('保存成功！');
            //                 this.dialogVisible = false;
            //                 this.$emit('submit');
            //             }
            //         });
            //     }
            // });
        }
    }
}
</script>

<style scoped lang="less">
.uploadDesignFilesContent{
    .submitButtonGroup{
        /deep/.el-form-item__content{
            text-align: center;
            margin-left: 0 !important;
            button{
                padding: 0;
                width: 120px;
                height: 35px;
                line-height: 35px;
                text-align: center;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/transaction/orderManagement/uploadDesignFiles.vue